<form [formGroup]="stepForm" *ngIf="stepForm">
  <div class="col-12">
    <h5 class="nmbcol">{{ 'Sellers.Products.ExtraInfo' | translate }} </h5>
    <div class="cardbg-white">
      <div class="row">
        <div class="col-6 mb-3">
          <app-image [fieldObject]="controllers['image']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['image'].fieldName)" [productType]="productTypeId"
            [isUpdate]="isUpdate"></app-image>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="cardbg-white my-3">
      <div class="row">
        <div class="col-md-6 mb-3">
          <app-product-categories [fieldObject]="controllers['category']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['category'].fieldName)" [productType]="productTypeId" [productTypeName]="productTypeName"
            [isUpdate]="isUpdate"></app-product-categories>
        </div>
        <div class="col-md-6 mb-3">
          <app-product-price [fieldObject]="controllers['Product_price']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['Product_price'].fieldName)" [productType]="productTypeId"
            [isUpdate]="isUpdate"></app-product-price>
        </div>
        <div class="col-md-3">
          <app-number [fieldObject]="controllers['available_quantity']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['available_quantity'].fieldName)"
            [productType]="productTypeId" [showIcon]=true [toolTipMsg]="QuantityDescription" [isUpdate]="isUpdate">
          </app-number>
        </div>
        <div class="col-md-3">
          <app-number [fieldObject]="controllers['pending_quantity']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['pending_quantity'].fieldName)" [productType]="productTypeId"
            [isUpdate]="isUpdate" [showIcon]=true [readonly]=true [toolTipMsg]="pendigQuantityDescription"></app-number>
        </div>
        <div class="col-md-3">
          <app-number [fieldObject]="controllers['paid_quantity']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['paid_quantity'].fieldName)" [productType]="productTypeId"
            [isUpdate]="isUpdate" [showIcon]=true [readonly]=true [toolTipMsg]="'Paid products'"></app-number>
        </div>
        <div class="col-md-3">
          <app-number [fieldObject]="controllers['maxQuantityPerSale']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['maxQuantityPerSale'].fieldName)"
            [productType]="productTypeId" [isUpdate]="isUpdate"></app-number>
        </div>
        <div class="col-md-6">
          <app-text-area [fieldObject]="controllers['Delivery_terms']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['Delivery_terms'].fieldName)" [productType]="productTypeId"
            [isUpdate]="isUpdate"></app-text-area>
        </div>
        <div class="col-md-6">
          <app-text-area [fieldObject]="controllers['Return_terms']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['Return_terms'].fieldName)" [productType]="productTypeId"
            [isUpdate]="isUpdate"></app-text-area>
        </div>
      </div>
    </div>
    <div class="cardbg-white my-3">
      <div class="col-12 mb-4 d-flex ">
        <app-toggle [fieldObject]="controllers['is_buyer_info']" [fieldErrors]="formValidator.formErrors"
          [formControlRef]="convertControls(controllers['is_buyer_info'].fieldName)" [productType]="productTypeId"
          [isUpdate]="isUpdate"></app-toggle>
      </div>
    </div>
  </div>
</form>
